<div [formGroup]="fg">
    <div class="action-setting">
        <div class="action-setting-title">
            {{ "commonActions.addLabelAction.chooseLabelTitle" | labelsProvider }}
        </div>

        <div class="action-setting-labels">
            <app-autocomplete-search
                [values]="searchLabelNameValues"
                (autocompleteOnChange)="labelNameSubmitted($event)"
                placeholder="Type here to search for a label">
            </app-autocomplete-search>
            <div style="overflow: scroll" [ngStyle]="{ height: searchLabelShownHeight }">
                <div *ngFor="let option of searchLabelShown">
                    <mat-checkbox
                        color="primary"
                        [checked]="checkedLabelIds.includes(option.id)"
                        (click)="$event.stopPropagation()"
                        (change)="onLabelSelect(option.id)">
                    </mat-checkbox>
                    {{ option.displayName }}
                </div>
            </div>
        </div>
        <br />
        <div class="action-setting-title">
            {{ "commonActions.addLabelAction.writeDescriptionTitle" | labelsProvider }}
        </div>
        <input class="action-setting-description" formControlName="description" type="text" placeholder="Type here to add a description" />
    </div>
</div>
